import { TranslateService } from '@ngx-translate/core';

import { getCronosDeliveryDateUseCase } from './get-chronos-delivery-date.use-case';
import { isCronosStatusUseCase } from './is-cronos-status.use-case';

// TODO ECOMDUTI-18440 [TechDebt] - Depender de modelos de datos de dominio, no de modelos de terceros como el que nos proporciona el API
import { Order } from '@api/order/order.models';
import { StoreAndLanguage } from '@core/domain/state/core.state';
import { DuttiDate, DuttiDateFormat } from '@frontend/common/duttidate';

// TODO ECOMDUTI-18440 [TechDebt] - MEJORAR CODIGO SEPARANDO EN METODOS MAS PEQUEÑOS
export function getOrderDeliveryDateUseCase(
    translateService: TranslateService,
    storeAndLanguage: Pick<StoreAndLanguage, 'languageCode' | 'countryCode'>,
    order: Partial<Order>,
    suborderId: number | string | null
) {
    let deliveryDate = '';
    let suborder;

    if (order.suborders.length > 1 && suborderId != null) {
        suborder = order.suborders.find((_suborder) => +_suborder.id === +suborderId);

        const orderTrackingSelected = order.orderTracking[suborder.id];

        deliveryDate = new DuttiDate(
            orderTrackingSelected.fechaEstimada,
            DuttiDateFormat.ISO
        )
            .browserTz().format(DuttiDateFormat.DAY_MONTH_YEAR_TRANSLATED);
    } else if (Object.keys(order.orderTracking)[0]) {
        const firstKey = Object.keys(order.orderTracking)[0];

        deliveryDate = new DuttiDate(
            order.orderTracking[firstKey].fechaEstimada,
            DuttiDateFormat.ISO
        )
            .browserTz().format(DuttiDateFormat.DAY_MONTH_YEAR_TRANSLATED);
    }

    let cronosDeliveryDate;
    if (order.suborders.length > 1 && suborderId != null) {
        cronosDeliveryDate = getCronosDeliveryDateUseCase(
            translateService,
            [order.orderTracking[suborder.id]],
            storeAndLanguage.languageCode,
            storeAndLanguage.countryCode
        );
    } else {
        cronosDeliveryDate = getCronosDeliveryDateUseCase(
            translateService,
            Object.values(order.orderTracking),
            storeAndLanguage.languageCode,
            storeAndLanguage.countryCode
        );
    }

    if (cronosDeliveryDate) {
        if (isCronosStatusUseCase(order.status)) {
            if (cronosDeliveryDate.minDate === cronosDeliveryDate.maxDate) {
                deliveryDate = cronosDeliveryDate.minDate;
            } else {
                deliveryDate = cronosDeliveryDate.minDate + '-' + cronosDeliveryDate.maxDate;
            }
        } else if (cronosDeliveryDate.deliveryDate) {
            deliveryDate = cronosDeliveryDate.deliveryDate;
        }
    }

    return deliveryDate;
}
